import Toast from '../components/pages/utils/Toast';
import { API } from '../constants/Constants';
import { DOCUMENT_TOAST } from '../constants/toastConstant';
import Instance from './interceptor';

export const getAllVersion = async (
  sorting,
  searchValue,
  filterModel,
  filterValue,
  id,
) => {
  const data = {
    searchData: searchValue,
    sortOrder: sorting?.[0]?.sort,
    sortField: sorting?.[0]?.colId,
    filterModel,
  };
  try {
    if (id) {
      const response = await Instance.post(
        `${API.GET_ALL_VERSION}/${id}`,
        data,
      );
      if (response?.data?.versions?.length === 0) {
        Toast({
          message: DOCUMENT_TOAST.NO_RECORDS,
          variant: 'warning',
          position: { vertical: 'top', horizontal: 'center' },
          autoHideDuration: 4000,
        });
        return response?.data?.versions;
      }
      return response?.data?.versions;
    }
  } catch (error) {
    Toast({ message: `${error?.message}`, variant: 'error' });
  }
};

export const addVersion = async (
  id,
  mappedResult,
  annotationData,
  newVersion,
) => {
  try {
    const data = {
      version: newVersion,
      annotation_data: annotationData,
      mapped_result: mappedResult,
    };
    return await Instance.post(`${API.ADD_VERSION_ANNOTATION}/${id}`, data);
  } catch (error) {
    Toast({ message: `${error?.message}`, variant: 'error' });
  }
};

export const renameVersion = async (invoiceId, versionId, versionName) => {
  const data = {
    version: versionName,
  };
  try {
    return await Instance.patch(`${API.RENAME_VERSION}`, data, {
      params: {
        id: invoiceId,
        versionId,
      },
    });
  } catch (error) {
    Toast({ message: `${error?.response?.data?.message}`, variant: 'error' });
  }
};

export const deleteOneVersion = async (invoiceId, versionId) => {
  try {
    return await Instance.delete(`${API.DELETE_VERSION}`, {
      params: {
        id: invoiceId,
        versionId,
      },
    });
  } catch (error) {
    Toast({ message: `${error?.response?.data?.message}`, variant: 'error' });
  }
};

export const getVersionAnnotationData = async (invoiceId, versionId) => {
  try {
    const response = await Instance.get(`${API.GET_VERSION_ANNOTATION}`, {
      params: {
        id: invoiceId,
        versionId,
      },
    });
    return response?.data?.document;
  } catch (error) {
    Toast({ message: error?.response?.data?.message, variant: 'error' });
  }
};

export const specificVersionValidate = async (
  annotationData,
  invoiceId,
  versionId,
) => {
  const data = {
    annotation_data: annotationData,
  };
  try {
    return await Instance.patch(`${API.SPECIFIC_VERSION_VALIDATE}`, data, {
      params: {
        id: invoiceId,
        versionId,
      },
    });
  } catch (error) {
    Toast({ message: error?.response?.data?.message, variant: 'error' });
  }
};
